import React from "react";
import PropTypes from "prop-types";
import { countries } from "helpers";

const BillingStepAddressCompressed = ({
  displayName,
  address,
  city,
  stateName,
  zip,
  countryName
}) => {
  return (
    <div className="checkout__step-body">
      <div>{displayName}</div>
      <div>{address}</div>
      <div>{`${city}, ${stateName} ${zip}`}</div>
      <div>{countries[countryName]}</div>
    </div>
  );
};

export default BillingStepAddressCompressed;

BillingStepAddressCompressed.propTypes = {
  displayName: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  stateName: PropTypes.string,
  zip: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired
};

BillingStepAddressCompressed.defaultProps = {
  stateName: null
};
